import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { QuickMap } from './components/QuickMap';
import { FeaturedReview } from './components/FeaturedReview';
import { Workflow } from './components/Workflow';
import { FitCheck } from './components/FitCheck';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { ClosingCTA } from './components/ClosingCTA';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { PurchaseNotice } from './components/PurchaseNotice';
import { CURRENCY, PRICE_VALUE, PRODUCT_NAME } from './components/Shared';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: PRODUCT_NAME,
      content_type: 'product',
      value: PRICE_VALUE,
      currency: CURRENCY
    });
  }, []);
  return <div lang="it" className="min-h-screen w-full overflow-x-hidden bg-stone-50 font-sans text-stone-900 antialiased selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0" data-mp="3rcj6618urx63">
      <AnnouncementBar data-id="element-1" data-mp="82kl3wchwbg" />
      <main data-id="element-2" data-mp="2zl3dbpgpde7f">
        <Hero data-id="element-3" data-mp="2zlldgx6hkckm" />
        <PackContents data-id="element-4" data-mp="2zm4yimrfnh2v" />
        <QuickMap data-id="element-5" data-mp="2zmo5j8fjol24" />
        <FeaturedReview data-id="element-6" data-mp="2zn6cp03qwjot" />
        <Workflow data-id="element-7" data-mp="33mf1dqjxhrdi" />
        <FitCheck data-id="element-8" data-mp="33lwzoeehyky7" />
        <Pricing data-id="element-9" data-mp="33ngfk3w8qtzg" />
        <Reviews data-id="element-10" data-mp="33myl9ct52pu6" />
        <FAQ data-id="element-11" data-mp="33oi0r16z0wuw" />
        <CostTable data-id="element-12" data-mp="38m1gy6n8bjph" />
        <ClosingCTA data-id="element-13" data-mp="38li7zffk45nl" />
        <Disclaimer data-id="element-14" data-mp="38l06a3a4kz8a" />
      </main>
      <Footer data-id="element-15" data-mp="38o4h3ji3it7x" />
      <PurchaseNotice data-id="element-16" data-mp="3dkurprb4swly" />
    </div>;
}